<template>
  <div v-if="isPersonalizedConfection" class="uploadFileForm">
    <h3>Dane osób do personalizacji nadruku (konfekcji)</h3>
    <p>
      <a :href="getPatternFile"><b>Pobierz szablon</b></a> i uzupełnij wymagane w nim dane, abyśmy
      mogli skonfigurować zamówienia na koperty z imiennym nadrukiem pod wyżej wskazany adres
      dostaw. Załącz plik poniżej.
    </p>
    <ValidationProvider
      :rules="rules"
      v-slot="{ validate, errors }"
      tag="div"
      class="form-group mb-0"
      ref="fileValidator"
    >
      <div>
        <input
          type="file"
          id="file"
          ref="file"
          @change="handleFileUpload($event) || validate($event)"
          style="display: none"
        />
        <p v-if="hasDeliveryFile && file" class="font-weight-bold">
          Załączono plik: {{ file.name }}
        </p>
        <div class="uploadFileForm__controls">
          <a :href="getPatternFile" class="btn btn-outline-primary">Pobierz szablon pliku</a>
          <a
            v-if="!isUploading"
            id="button"
            role="button"
            href="#"
            class="btn"
            :class="hasDeliveryFile ? 'btn-outline-primary' : 'btn-primary'"
            @click.prevent="$refs.file.click()"
          >
            {{ getMessage }}
          </a>
          <a
            v-if="hasDeliveryFile"
            :href="getUrl"
            target="_blank"
            class="btn btn-outline-secondary"
          >
            Zobacz swój załączony plik
          </a>
        </div>
        <div>
          <CustomAlert type="warning" :open.sync="alert" class="mt-5">
            <b>Uwaga!</b><br />{{ errorMsg }}
          </CustomAlert>
        </div>
        <img class="loader" src="/images/loader.gif" v-if="isUploading" />
        <ul class="errors">
          <li class="text-danger">{{ errors[0] }}</li>
        </ul>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import fileRepository from '../../repositories/fileRepository';
import CustomAlert from '../CustomAlert.vue';

export default {
  components: { CustomAlert },
  name: 'UploadFile',
  /*
      Defines the data used by the component
    */
  data() {
    return {
      file: '',
      uploading: false,
      alert: false,
      errorMsg: '',
    };
  },
  props: ['delivery_id'],
  computed: {
    ...mapState({
      hasIndividualPersonalization: state => state.confection.hasIndividualPersonalization,
    }),
    rules() {
      return this.hasDeliveryFile && this.$store.state.confection.isConfectionEnabled
        ? ''
        : 'required';
    },
    getMessage() {
      if (this.hasDeliveryFile) return 'Prześlij plik ponownie';
      return 'Prześlij plik';
    },
    isUploading() {
      return this.uploading;
    },
    hasDeliveryFile() {
      if (
        typeof this.$store.getters['delivery/getDeliveryFile'](this.delivery_id) === 'undefined'
        || this.$store.getters['delivery/getDeliveryFile'](this.delivery_id) === ''
      ) return false;
      return true;
    },
    getToken() {
      return this.$store.state.delivery.address[this.delivery_id].token;
    },
    getUrl() {
      return `${process.env.VUE_APP_BASE_URL}/api/v1/file/download/${this.getToken}`;
    },
    isProductPhysicalCard() {
      return this.$store.getters.isProductPhysicalCard;
    },
    isNde() {
      return this.$store.getters.isProductNDE;
    },
    getPatternFile() {
      if (this.isNde && this.isProductPhysicalCard) {
        return '/docs/formularze_zamowien/Zalacznik_do_konfekcji_kart–wzor.xlsx';
      }

      const type = this.isProductPhysicalCard ? 'kart' : 'kuponow';
      return `https://cdn.pluxee.pl/panel-klienta/example_files/Zalacznik_do_konfekcji_${type}%E2%80%93wzor.xlsx`;
    },
    isConfection() {
      return this.$store.state.confection.isConfectionEnabled;
    },
    confectionOnDelivery() {
      const items = this.$store.state.delivery.products;
      return items.filter(
        product => ['KONF', 'KONF_PRD'].includes(product.product_category)
          && product.iddelivery === this.delivery_id
          && product.quantity > 0,
      );
    },
    isPersonalizedConfection() {
      if (!this.isNde) {
        return (
          this.isConfection
          && !this.confectionOnDelivery.every(item => [
            'wlozenie-kuponow-do-kopert-ozdobnych',
            'wlozenie-kopert-z-kartami-do-etui-ozdobnego-sodexo',
            'wlozenie-karty-do-ozdobnego-etui',
          ].includes(item.slug))
        );
      }

      return (
        this.$store.getters['delivery/hasPersonalizedConfectionInCart']
        && this.hasIndividualPersonalization
      );
    },
  },
  methods: {
    /*
        Submits the file to the server
      */
    submitFile() {
      this.uploading = true;
      fileRepository
        .uploadFile(this.getToken, this.file, this.isNde)
        .then(({ data }) => {
          // eslint-disable-next-line
          if (data.error) {
            this.file = '';
            this.$store.dispatch('delivery/setDeliveryFile', {
              index: this.delivery_id,
              fileName: '',
            });
            this.uploading = false;
            this.alert = true;
            this.errorMsg = data.error.message;
            this.isFileVaild = false;
          } else {
            // eslint-disable-next-line prefer-destructuring
            this.$store.dispatch('delivery/setDeliveryFile', {
              index: this.delivery_id,
              fileName: this.file.name,
            });
            this.uploading = false;
            this.alert = false;
            this.errorMsg = '';
            this.isFileVaild = true;
          }
        })
        .catch(() => {
          this.file = '';
          this.$store.dispatch('delivery/setDeliveryFile', {
            index: this.delivery_id,
            fileName: '',
          });
          this.uploading = false;
          this.errorMsg = 'Wystąpił błąd podczas przesyłania pliku';
          this.alert = true;
          this.isFileVaild = false;
        });
    },

    /*
        Handles a change on the file upload
      */
    handleFileUpload() {
      // eslint-disable-next-line prefer-destructuring
      this.file = this.$refs.file.files[0];
      this.submitFile();
    },
  },
};
</script>
